<template>
  <div v-loading="loading">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="bg-purple bcGrey">
          <el-form ref="form" label-position="left" label-width="auto" class="grey padding10">
            <el-form-item label="渠道单号">
              <el-input v-model="data.channelOrderNo" placeholder="请输入订单号" type="text" style="width: 260px;" @blur="handleBlur"></el-input>
            </el-form-item>
            <el-form-item label="线上店铺">
              <el-select v-model="data.cshop" filterable placeholder="请选择线上店铺" style="width: 260px;">
                <el-option v-for="item in shopList" :key="item.sid" :label="item.cname" :value="item.rplatShop"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出货门店">
              <el-select v-model="data.rstore" filterable placeholder="请选择出货门店" style="width: 260px;">
                <el-option v-for="item in storeList" :key="item.sid" :label="item.cname" :value="item.sid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="顾客姓名">
              <el-input v-model="data.customerName" placeholder="请输入顾客姓名" type="text" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="顾客电话">
              <el-input v-model="data.customerPhone" placeholder="请输入顾客电话" type="text" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="顾客地址">
              <el-input v-model="data.customerAddr" placeholder="请输入顾客地址" type="textarea" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="顾客详细地址">
              <el-input v-model="data.customerAddrDetail" placeholder="请输入顾客详细地址" type="textarea" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="期望送达时间">
              <el-time-select v-model="data.wishTime" placeholder="选择时间" style="width: 260px;">
              </el-time-select>
            </el-form-item>
            <el-form-item label="顾客实付">
              <el-input v-model="data.priceCustomer" placeholder="请输入顾客实付（单位：元）" type="text" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="经度">
              <el-input v-model="data.customerLongitude" placeholder="请点击地图获取" type="text" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="纬度">
              <el-input v-model="data.customerLatitude" placeholder="请点击地图获取" type="text" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="配送方式">
              <el-radio v-model="data.deliveryType" label="1">同城配送</el-radio>
              <el-radio v-model="data.deliveryType" label="2">顾客自提</el-radio>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="bg-purple-light bcGrey hHP">
          <el-form ref="form-goods" label-width="auto" class="grey padding10">
            <div v-if="goodsList.length > 0" class="bcGrey padding10 marginBottom10 scrollbar" style="height: 290px">
              <div v-for="(goods, index) in goodsList" :key="goods.sid" class="marginBottom10">
                <div class="wHP bcWhite flex padding5">
                  <el-image :preview-src-list="[goods.cmasterUrl]" class="w60 h60 marginRight5" fit="fit" :src="goods.cmasterUrl" />
                  <div class="flex1">
                    <div class="fs20 blue">{{ goods.cname }}</div>
                    <div class="flex marginTopAuto alignItemsCenter">
                      <div style="width: 35%">单价: {{ goods.nprice }}</div>
                      <div class="flexGrow">数量: {{ goods.num }}</div>
                      <el-button type="primary" style="margin-left: auto" icon="el-icon-delete" @click="handleRemoveGoods(index)"></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-button class="wHP block" type="primary" plain @click="handleShowChooseGoods">+ 添加货品</el-button>
          </el-form>
        </div>
      </el-col>
      <el-col :span="8">
        <div style="height: 800px;width: 400px;">
          <div id="container" class="hHP wHP" />
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end">
      <el-button type="primary" plain @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </el-row>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="添加货品" :visible.sync="dialogVisible" width="1000px" append-to-body>
      <inventOrderGoodsAdd v-if="dialogVisible" :select-store="{ rstore: data.rstore }" @handleClose="dialogVisible = false" @handleChoose="handleChooseGiveGoods" />
    </el-dialog>
  </div>
</template>

<script>
import inventOrderGoodsAdd from "./dialog/inventOrderGoodsAdd.vue";

export default {
  name: "OrderCreateInfo",
  components: { inventOrderGoodsAdd },
  props: {
    ordId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      shopList: [],
      storeList: [],
      map: null,
      markers: [],
      loading: false,
      data: {
        deliveryType: "1",
        cshop: "",
        rstore: "",
        customerLongitude: 112.256166,
        customerLatitude: 31.709557,
        priceCustomer: "0",
      },
      goodsList: []
    };
  },
  mounted() {
    this.handleQueryShopList();
    this.handleQueryStoreList();
    this.getStoreLocation();
  },
  methods: {
    handleChooseGiveGoods(goodsList) {
      console.log(goodsList)
      let arr = this.goodsList;
      for (let i = 0; i < goodsList.length; i++) {
        arr.push(goodsList[i]);
      }
      this.goodsList = arr;
      this.dialogVisible = false;
    },
    handleQueryShopList() {
      this.topsAjax.get(`${this.baseUrls.shop}/queryList`, {
        bDelete: 0,
        bValid: 1,
      }).then((res) => {
        this.shopList = res;
      });
    },
    handleQueryStoreList() {
      this.topsAjax.get(`${this.baseUrls.orderStore}/queryList`, { bStatus: 2 }).then((response) => {
        this.storeList = response;
      });
    },
    handleShowChooseGoods() {
      if (this.data.rstore !== "") {
        this.dialogVisible = true;
      } else {
        this.$message.error("请选择门店");
      }
    },
    handleRemoveGoods(index) {
      this.goodsList.splice(index, 1);
    },
    getStoreLocation() {
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 15,
        center: [this.data.customerLongitude, this.data.customerLatitude],
      });
      AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], () => {
        this.map.addControl(new AMap.ToolBar());//缩放工具条实例化
        this.map.addControl(new AMap.Scale());//比例尺
      });
      this.map.on("click", (evt) => {
        this.data.customerLongitude = evt.lnglat.getLng().toFixed(6); // 保留6位小数
        this.data.customerLatitude = evt.lnglat.getLat().toFixed(6);
        this.mapMarkers();
      });
    },
    mapMarkers() {
      this.map.remove(this.markers)
      this.markers = [];

      const marker = new AMap.Marker({
        position: new AMap.LngLat(this.data.customerLongitude, this.data.customerLatitude), //经纬度对象
      });
      this.markers.push(marker);
      this.map.add(marker);
      this.map.setFitView([ marker ]);
    },
    handleBlur() {
      this.topsAjax.get(`${this.baseUrls.third}/getByOrderNo`, { orderNo: this.data.channelOrderNo }).then((response) => {
        this.data.cshop = response.cshop;
        this.data.sshop = response.sshop;
        this.data.rstore = response.rstore;
        this.data.sstore = response.sstore;
        this.data.customerName = response.ccustomerName;
        this.data.customerPhone = response.ccustomerPhone;
        this.data.customerAddr = response.ccustomerAddr;
        this.data.wishTime = response.swishTime;
        this.data.customerLongitude = response.ccustomerLongitude;
        this.data.customerLatitude = response.ccustomerLatitude;
        this.data.customerAddrDetail = response.ccustomerAddrDetail;
      });
    },
    handleSave() {
      if (this.data.cshop === "") {
        this.$message.error("请选择店铺");
        return;
      }
      if (this.data.rstore === "") {
        this.$message.error("请选择门店");
        return;
      }
      for (let i = 0; i < this.shopList.length; i++) {
        if (this.data.cshop === this.shopList[i].rplatShop) {
          this.data.sshop = this.shopList[i].cname;
          break;
        }
      }
      for (let i = 0; i < this.storeList.length; i++) {
        if (this.data.rstore === this.storeList[i].sid) {
          this.data.sstore = this.storeList[i].cname;
          this.data.storeAddr = this.storeList[i].caddr;
          break;
        }
      }
      this.data.goodsList = this.goodsList;
      this.loading = true;
      this.topsAjax.post(`${this.baseUrls.topsOrder}/create`, this.data).then(() => {
        this.loading = false;
        this.$message.success("保存成功");
        this.$emit("close-dialog");
      });
    },
    handleClose() {
      this.$emit("close-dialog");
    }
  },
};
</script>

<style lang="scss">
.amap-sug-result {
  z-index: 9999;
}

.orderInfoAD {
  width: 100%;

  .el-input {
    width: 270px;
  }

  .el-picker-panel__body > .el-date-picker__time-header > .el-date-picker__editor-wrap > .el-input {
    width: 100% !important;
  }

  .orderGoodsAddDialog {
    .el-date-picker__time-header > div {
      width: 100% !important;
    }

    .el-dialog__body {
      background-color: white !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.el-select-dropdown__item {
  height: auto;
}
</style>
